import { render, staticRenderFns } from "./OwnerId.vue?vue&type=template&id=1ad2d05c&lang=pug"
import script from "./OwnerId.vue?vue&type=script&lang=js"
export * from "./OwnerId.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports